// Configuracion de validadores

export const FIELD_LABELS = {
  firstname: 'Nombre',
  lastnameFirst: 'Primer apellido',
  lastnameSecond: 'Segundo apellido',
  municipality: 'Alcaldía',
  city: 'Ciudad',
  street: 'Calle'
};

export const minLengthValidator = (value, min, what = 'caracteres') => {
  if (value === null || value === undefined) return null;

  if (String(value).trim().length < min) {
    return `Debe tener al menos ${min} ${what}`;
  }
  return null;
};

export const passwordValidator = (value) => {
  if (value === null || value === undefined) return "La contraseña es requerida";

    const errors = [];

  if (value.length < 8 || value.length > 15) {
    return 'La contraseña debe contener de 8 a 15 caracteres';
  }

  if (!/[A-Z]/.test(value)) {
    return "Debe incluir al menos una mayúscula";
  }
  if (!/[a-z]/.test(value)) {
    return "Debe incluir al menos una minúscula";
  }
  if (!/[0-9]/.test(value)) {
    return "Debe incluir al menos un número";
  }

  if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
    return "Debe incluir al menos un carácter especial";
  }

  return errors.length > 0 ? errors : null;
};

export const emailValidator = (value) => {
  if (!value) return 'Email es requerido';
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
    return 'Email inválido';
  }
  return null;
};

export const phoneValidator = (value) => {
    const trimmed = String(value ?? '').trim();

  if (trimmed === '') return null; // optional

  if (!/^\+?[0-9]{10,13}$/.test(trimmed)) {
    return 'Teléfono inválido (10–13 dígitos, sin espacios ni símbolos)';
  }

  return null;
};

export const nameValidator = (value, campo = 'Nombre') => {
  if (!value) return null; // opcional

  const regex = /^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ\s'-]{2,100}$/;

  if (!regex.test(value.trim())) {
    return `${campo} inválido (2–100 caracteres alfabéticos)`;
  }

  return null;
};

export const streetNameValidator = (value, campo = 'Calle') => {
  if (!value) return null; // optional

  const regex = /^[A-Za-zÁÉÍÓÚÜÑáéíóúüñ0-9\s.,#'\/-]{2,100}$/;

  if (!regex.test(value.trim())) {
    return `${campo} inválido (2–100 caracteres)`;
  }

  return null;
};

export const zipCodeValidator = (value, campo = 'Código postal') => {
  if (value === null || value === undefined || value === '') return null;

  const stringValue = String(value).trim();
  const regex = /^\d{5}$/;

  if (!regex.test(stringValue)) {
    return `${campo} inválido (5 dígitos)`;
  }

  return null;
};

export const latLongValidator = (value, campo = 'Coordenada') => {
  if (value === null || value === undefined || value === '') return null;

  const stringValue = String(value).trim();
  const regex = /^-?\d{1,3}\.\d+$/;

  if (!regex.test(stringValue)) {
    return `${campo} inválida (debe ser un número decimal)`;
  }

  const numValue = parseFloat(stringValue);
  if (numValue < -180 || numValue > 180) {
    return `${campo} inválida (debe estar entre -180 y 180)`;
  }

  return null;
}

export const rfcValidator = (value) => {
  if (!value) return null;

  const trimmed = value.trim();

  if (trimmed.length !== 12 && trimmed.length !== 13) {
    return 'RFC debe tener 12 o 13 caracteres';
  }
  const rfcRegex = /^([A-ZÑ&]{3,4})\d{6}[A-Z0-9]{3}$/i;

  if (!rfcRegex.test(trimmed)) {
    return 'RFC formato inválido';
  }

  return null; // valid
};

export const curpValidator = (value) => {
  if (!value) return null;

  const curpRegex = /^[A-Z0-9]{18}$/i;
  if (!curpRegex.test(value.trim())) {
    return "CURP inválido";
  }

  return null; // valid
};

export const numbersOnlyValidator = (value) => {
  if (value === null || value === undefined || value === '') return null;

  if (!/^\d+$/.test(String(value).trim())) {
    return 'Solo se permiten números';
  }
  return null;
};

export const requiredValidator = (value, label = 'Campo') => {
  if (value === null || value === undefined || String(value).trim() === '') {
    return `${label} requerido`;
  }
  return null;
};

export const validateField = (value, validators = []) => {
  for (const validator of validators) {
    const error = validator(value);
    if (error) return error;
  }
  return null;
};